import {Col, Row} from 'react-bootstrap'
import {Modal} from 'rsuite'
import {imageBaseUrl} from 'src/cms/helpers/constants'

type Props = {
  data: {
    id: String
    name: String
    uniqueCode: String
    dobAd: String
    dobBs: String
    age: String
    gender: String
    grandfatherName: String
    fatherName: String
    motherName: String
    placeOfBirth: String
    bloodGroup: String
    citizenshipNumber: String
    districtId: String
    citizenshipIssueDateAd: String
    citizenshipIssueDateBs: String
    maritalStatus: String
    nameOfSpouse: String
    email: String
    mobileNumber: String
    telephone: String
    pan: String
    licenseHolder: String
    departmentId: String
    coreBanking: String
    cbsName: String
    cbsExperience: String
    bankingExperience: String
    transcriptInHand: String
    application: String
    sameAsPermanent: boolean
    workedHere: boolean
    headHuntApplicantStatusId: String
    status: boolean
    headHuntApplicantPermanentAddress: {
      id: String
      headHuntApplicantId: String
      provinceId: String
      zoneId: String
      districtId: String
      municipalityId: String
      wardNumber: String
      tole: String
    }
    headHuntApplicantTemporaryAddress: {
      id: String
      headHuntApplicantId: String
      provinceId: String
      zoneId: String
      districtId: String
      municipalityId: String
      wardNumber: String
      tole: String
    }
    headHuntApplicantEducation: {
      headHuntApplicantEducation: [
        {
          id: String
          headHuntApplicantId: String
          nameAddressInstituition: String
          university: String
          qualificationId: String
          areaSpecialization: String
          passingYear: String
          percentage: String
          cgpa: String
          marksheet: String
        }
      ]
    }
    headHuntApplicantTraining: {
      headHuntApplicantTraining: [
        {
          id: String
          headHuntApplicantId: String
          name: String
          instituteName: String
          startDate: String
          endDate: String
        }
      ]
    }
    headHuntApplicantProfessionalReference: {
      headHuntApplicantProfessionalReference: [
        {
          id: String
          headHuntApplicantId: String
          name: String
          address: String
          email: String
          phoneNumber: String
          organizationName: String
        }
      ]
    }
    headHuntApplicantDocument: {
      id: String
      headHuntApplicantId: String
      latestPhoto: String
      resume: String
      frontCitizenship: String
      backCitizenship: String
      latestDegree: String
      application: String
    }
    headHuntApplicantCurrentExperience: {
      headHuntApplicantCurrentExperience: [
        {
          id: String
          headHuntApplicantId: String
          organizationName: String
          designation: String
          functionalAreaId: String
          fromDate: String
          toDate: String
          salaryPerMonth: String
          jobResponsibilities: String
          lastPromotionDate: String
          document: String
          expectedSalary: String
        }
      ]
    }
    headHuntApplicantRecentExperience: {
      headHuntApplicantRecentExperience: [
        {
          id: String
          headHuntApplicantId: String
          organizationName: String
          designation: String
          functionalAreaId: String
          fromDate: String
          toDate: String
          salaryPerMonth: String
          jobResponsibilities: String
          totalMonth: String
          reasonForLeaving: String
        }
      ]
    }
    headHuntApplicantWorkedHereDetail: {
      id: String
      headHuntApplicantId: String
      branchId: String
      departmentId: String
      position: String
      fromDate: String
      toDate: String
      status: String
    }
    headHuntApplicantPreferredBranches: {
      headHuntApplicantPreferredBranch: [
        {
          id: String
          headHuntApplicantId: String
          branchId: String
        }
      ]
    }
    headHuntApplicantFamilyBankReference: {
      id: String
      headHuntApplicantId: String
      fullName: String
      branch: String
      email: String
      phoneNumber: String
    }
  }
  handleClose: () => void
  provinceList: Array<any>
  districtList: Array<any>
  zoneList: Array<any>
  municipalityList: Array<any>
  functionalAreaList: Array<any>
  branchList: Array<any>
  departmentList: Array<any>
  onShortlist?: () => void
  onReject?: () => void
}

const ViewCandidateDetails = ({
  data,
  handleClose,
  branchList,
  departmentList,
  provinceList,
  districtList,
  zoneList,
  municipalityList,
  functionalAreaList,
  onShortlist,
  onReject,
}: Props) => {
  return (
    <div className='modal-container' data-cy='head-hunt-container'>
      <Modal
        open={true}
        onClose={handleClose}
        className='w-75'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>Candidate Details </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h5>Personal Details</h5>
            <Row>
              <Col md={3}>Name : {data?.name}</Col>
              <Col md={3}>Unique Code : {data?.uniqueCode}</Col>
              <Col md={3}>Date Of Birth (B.S): {data?.dobBs}</Col>
              <Col md={3}>Date Of Birth (A.D): {data?.dobAd}</Col>
            </Row>
            <Row className='mt-5'>
              <Col md={3}>Age : {data?.age}</Col>
              <Col md={3}>Gender : {data?.gender}</Col>
              <Col md={3}>Father's Name: {data?.fatherName}</Col>
              <Col md={3}>Grandfather's Name: {data?.grandfatherName}</Col>
            </Row>
            <Row className='mt-5'>
              <Col md={3}>Mother's Name : {data?.motherName}</Col>
              <Col md={3}>Marital Status : {data?.maritalStatus}</Col>
              {String(data?.maritalStatus)?.toLowerCase() === 'married' && (
                <Col md={3}>Name of Spouse : {data?.nameOfSpouse || 'N/A'}</Col>
              )}
            </Row>
            <Row className='mt-5'>
              <Col md={3}>Place Of Birth : {data?.placeOfBirth}</Col>
              <Col md={3}>Blood Group : {data?.bloodGroup}</Col>
              <Col md={3}>Citizenship Number: {data?.citizenshipNumber}</Col>
              <Col md={3}>Citizenship Issued Date (B.S): {data?.citizenshipIssueDateBs}</Col>
            </Row>
            <Row className='mt-5'>
              <Col md={3}>Citizenship Issued Date (A.D): {data?.citizenshipIssueDateAd}</Col>
              <Col md={3}>Email : {data?.email}</Col>
              <Col md={3}>Mobile Number: {data?.mobileNumber}</Col>
              <Col md={3}>Home Telephone: {data?.telephone || 'N/A'}</Col>
            </Row>
            <Row className='mt-5'>
              <Col md={3}>PAN: {data?.pan || 'N/A'}</Col>
              <Col md={3}>License Holder: {data?.licenseHolder || 'N/A'}</Col>
              <Col md={3}>
                Preferred Department:{' '}
                {departmentList.filter((d: any) => d.id === data?.departmentId)[0]?.name || 'N/A'}
              </Col>
              <Col md={3}>
                Preferred Branch(es):{' '}
                {data?.headHuntApplicantPreferredBranches?.headHuntApplicantPreferredBranch
                  ?.map(
                    (pb: any) =>
                      branchList.filter((d: any) => d.id === pb.branchId)[0]?.title || 'N/A'
                  )
                  .join(', ') || 'N/A'}
              </Col>
            </Row>
            <Row className='mt-5'>
              <Col md={3}>Experience in Core Banking: {data?.coreBanking || 'N/A'}</Col>
              {String(data?.coreBanking)?.toLowerCase() === 'yes' && (
                <>
                  <Col md={3}>Name of CBS: {data?.cbsName || 'N/A'}</Col>
                  <Col md={3}>CBS Experience: {data?.cbsExperience || 'N/A'}</Col>
                </>
              )}
              <Col md={3}>Total Banking Experience (months): {data?.bankingExperience || 'None'}</Col>
            </Row>
            <Row className='mt-5'>
              <Col md={3}>Transcript in Hand: {data?.transcriptInHand || 'N/A'}</Col>
              <Col md={12}>Application: {data?.application || 'N/A'}</Col>
            </Row>
            <Row className='mt-5'>
              <Col md={3}>
                Permanent Province:{' '}
                {provinceList.filter(
                  (d: any) => d.id === data?.headHuntApplicantPermanentAddress?.provinceId
                )[0]?.title || 'N/A'}
              </Col>
              <Col md={3}>
                Permanent Zone:{' '}
                {zoneList.filter(
                  (d: any) => d.id === data?.headHuntApplicantPermanentAddress?.zoneId
                )[0]?.title || 'N/A'}
              </Col>
              <Col md={3}>
                Permanent District:{' '}
                {districtList.filter(
                  (d: any) => d.id === data?.headHuntApplicantPermanentAddress?.districtId
                )[0]?.title || 'N/A'}
              </Col>
              <Col md={3}>
                Permanent Municipality/VDC:{' '}
                {municipalityList.filter(
                  (d: any) => d.id === data?.headHuntApplicantPermanentAddress?.municipalityId
                )[0]?.title || 'N/A'}
              </Col>
            </Row>
            <Row className='mt-5'>
              <Col md={3}>
                Permanent Ward Number: {data?.headHuntApplicantPermanentAddress?.wardNumber}
              </Col>
              <Col md={3}>Permanent Tole: {data?.headHuntApplicantPermanentAddress?.tole}</Col>
              <Col md={3}>
                Present Province:{' '}
                {provinceList.filter(
                  (d: any) => d.id === data?.headHuntApplicantTemporaryAddress?.provinceId
                )[0]?.title || 'N/A'}
              </Col>
              <Col md={3}>
                Present Zone:{' '}
                {zoneList.filter(
                  (d: any) => d.id === data?.headHuntApplicantTemporaryAddress?.zoneId
                )[0]?.title || 'N/A'}{' '}
              </Col>
            </Row>
            <Row className='mt-5'>
              <Col md={3}>
                Present District:{' '}
                {districtList.filter(
                  (d: any) => d.id === data?.headHuntApplicantTemporaryAddress?.districtId
                )[0]?.title || 'N/A'}
              </Col>
              <Col md={3}>
                Present Municipality/VDC:{' '}
                {municipalityList.filter(
                  (d: any) => d.id === data?.headHuntApplicantTemporaryAddress?.municipalityId
                )[0]?.title || 'N/A'}
              </Col>
              <Col md={3}>Present Tole: {data?.headHuntApplicantTemporaryAddress?.tole}</Col>
            </Row>

            <h5 className='mt-5'>Education Details</h5>
            {data?.headHuntApplicantEducation?.headHuntApplicantEducation?.map(
              (education: any, index: number) => {
                return (
                  <div key={index}>
                    <h5 className='mt-2'>Education {index + 1}</h5>
                    <Row className='mt-5'>
                      <Col md={3}>University/College: {education?.university}</Col>
                      <Col md={3}>Institution Address : {education?.nameAddressInstituition}</Col>
                      <Col md={3}>Area Of Specialization: {education?.areaSpecialization}</Col>
                      <Col md={3}>Passing Year: {education?.passingYear}</Col>
                    </Row>
                    <Row className='mt-5'>
                      <Col md={3}>CGPA: {education?.cgpa}</Col>
                      <Col md={3}>Percentage : {education?.percentage}</Col>
                    </Row>
                  </div>
                )
              }
            )}

            <h5 className='mt-5'>Training Details</h5>
            {data?.headHuntApplicantTraining?.headHuntApplicantTraining?.map(
              (training: any, index: number) => {
                return (
                  <div key={index}>
                    <h5 className='mt-2'>Training {index + 1}</h5>
                    <Row className='mt-5'>
                      <Col md={3}>Training Name: {training?.name}</Col>
                      <Col md={3}>Institute Name : {training?.instituteName}</Col>
                      <Col md={3}>Start Date: {training?.startDate || 'N/A'}</Col>
                      <Col md={3}>End Date: {training?.endDate || 'N/A'}</Col>
                    </Row>
                  </div>
                )
              }
            )}

            <h5 className='mt-5'>Current Experience Details</h5>
            {data?.headHuntApplicantCurrentExperience?.headHuntApplicantCurrentExperience?.map(
              (currentExperience: any, index: number) => {
                return (
                  <div key={index}>
                    <h5 className='mt-2'>Current Experience {index + 1}</h5>
                    <Row className='mt-5'>
                      <Col md={3}>Organization Name: {currentExperience?.organizationName}</Col>
                      <Col md={3}>Designation: {currentExperience?.designation}</Col>
                      <Col md={3}>
                        Functional Area:{' '}
                        {functionalAreaList.filter(
                          (d: any) => d.id === currentExperience.functionalAreaId
                        )[0]?.name || 'N/A'}
                      </Col>
                      <Col md={3}>Salary Per Month: {currentExperience?.salaryPerMonth}</Col>
                    </Row>
                    <Row className='mt-5'>
                      <Col md={3}>From Date: {currentExperience?.fromDate}</Col>
                      <Col md={3}>To Date: {currentExperience?.toDate}</Col>
                      <Col md={3}>
                        Job Responsibilities: {currentExperience?.jobResponsibilities}
                      </Col>
                      <Col md={3}>Last Promotion Date: {currentExperience?.lastPromotionDate}</Col>
                    </Row>
                    <Row className='mt-5'>
                      <Col md={3}>
                        Document:{' '}
                        <a target='_blank' href={imageBaseUrl + '/' + currentExperience?.document}>
                          View
                        </a>
                      </Col>
                      <Col md={3}>Expected Salary: {currentExperience?.expectedSalary}</Col>
                    </Row>
                  </div>
                )
              }
            )}

            <h5 className='mt-5'>Recent Experience Details</h5>
            {data?.headHuntApplicantRecentExperience?.headHuntApplicantRecentExperience?.map(
              (recentExperience: any, index: number) => {
                return (
                  <div key={index}>
                    <h5 className='mt-2'>Recent Experience {index + 1}</h5>
                    <Row className='mt-5'>
                      <Col md={3}>Organization Name: {recentExperience?.organizationName}</Col>
                      <Col md={3}>Designation: {recentExperience?.designation}</Col>
                      <Col md={3}>
                        Functional Area:{' '}
                        {functionalAreaList.filter(
                          (d: any) => d.id === recentExperience.functionalAreaId
                        )[0]?.name || 'N/A'}
                      </Col>
                      <Col md={3}>Salary Per Month: {recentExperience?.salaryPerMonth}</Col>
                    </Row>
                    <Row className='mt-5'>
                      <Col md={3}>From Date: {recentExperience?.fromDate}</Col>
                      <Col md={3}>To Date: {recentExperience?.toDate}</Col>
                      <Col md={3}>
                        Job Responsibilities: {recentExperience?.jobResponsibilities}
                      </Col>
                      <Col md={3}>Total Month: {recentExperience?.totalMonth}</Col>
                    </Row>
                    <Row className='mt-5'>
                      <Col md={3}>Reason for leaving: {recentExperience?.reasonForLeaving}</Col>
                    </Row>
                  </div>
                )
              }
            )}

            {data?.headHuntApplicantWorkedHereDetail?.position && (
              <>
                <h5 className='mt-5'>Worked Here Details</h5>
                <Row className='mt-5'>
                  <Col md={3}>
                    Branch Name:{' '}
                    {branchList.filter(
                      (d: any) => d.id === data?.headHuntApplicantWorkedHereDetail?.branchId
                    )[0]?.title || 'N/A'}
                  </Col>
                  <Col md={3}>
                    Department:{' '}
                    {departmentList.filter(
                      (d: any) => d.id === data.headHuntApplicantWorkedHereDetail?.departmentId
                    )[0]?.name || 'N/A'}
                  </Col>
                  <Col md={3}>Position: {data?.headHuntApplicantWorkedHereDetail?.position}</Col>
                  <Col md={3}>From Date: {data?.headHuntApplicantWorkedHereDetail?.fromDate}</Col>
                </Row>
                <Row className='mt-5'>
                  <Col md={3}>To Date: {data?.headHuntApplicantWorkedHereDetail?.toDate}</Col>
                  <Col md={3}>Status: {data?.headHuntApplicantWorkedHereDetail?.status}</Col>
                </Row>
              </>
            )}

            <h5 className='mt-5'>Reference Details</h5>
            {data?.headHuntApplicantProfessionalReference?.headHuntApplicantProfessionalReference?.map(
              (reference: any, index: number) => {
                return (
                  <div key={index}>
                    <h5 className='mt-2'>Reference {index + 1}</h5>
                    <Row className='mt-5'>
                      <Col md={3}>Name: {reference?.name}</Col>
                      <Col md={3}>Address: {reference?.address}</Col>
                      <Col md={3}>Email: {reference?.email}</Col>
                      <Col md={3}>Phone Number: {reference?.phoneNumber}</Col>
                    </Row>
                    <Row className='mt-5'>
                      <Col md={3}>Organization Name: {reference?.organizationName}</Col>
                    </Row>
                  </div>
                )
              }
            )}

            <h5 className='mt-5'>Details if any immediate family or cousin is currently working in the bank</h5>
            <Row className='mt-5'>
              <Col md={3}>
                Full Name: {data?.headHuntApplicantFamilyBankReference?.fullName || 'N/A'}
              </Col>
              <Col md={3}>Branch: {data?.headHuntApplicantFamilyBankReference?.branch || 'N/A'}</Col>
              <Col md={3}>Email: {data?.headHuntApplicantFamilyBankReference?.email || 'N/A'}</Col>
              <Col md={3}>
                Phone Number: {data?.headHuntApplicantFamilyBankReference?.phoneNumber || 'N/A'}
              </Col>
            </Row>

            <h5 className='mt-5'>Document Details</h5>
            <Row className='mt-5'>
              <Col md={3}>
                Latest Photo:{' '}
                <a
                  target='_blank'
                  href={imageBaseUrl + '/' + data?.headHuntApplicantDocument?.latestPhoto}
                >
                  View
                </a>
              </Col>
              <Col md={3}>
                Resume:{' '}
                <a
                  target='_blank'
                  href={imageBaseUrl + '/' + data?.headHuntApplicantDocument?.resume}
                >
                  View
                </a>
              </Col>
              <Col md={3}>
                Front Citizenship:{' '}
                <a
                  target='_blank'
                  href={imageBaseUrl + '/' + data?.headHuntApplicantDocument?.frontCitizenship}
                >
                  View
                </a>
              </Col>
              <Col md={3}>
                Back Citizenship:{' '}
                <a
                  target='_blank'
                  href={imageBaseUrl + '/' + data?.headHuntApplicantDocument?.backCitizenship}
                >
                  View
                </a>
              </Col>
              <Col md={3}>
                Application:{' '}
                <a
                  target='_blank'
                  href={imageBaseUrl + '/' + data?.headHuntApplicantDocument?.application}
                >
                  View
                </a>
              </Col>
              <Col md={3} className='mt-4'>
                Latest Degree:{' '}
                <a
                  target='_blank'
                  href={imageBaseUrl + '/' + data?.headHuntApplicantDocument?.latestDegree}
                >
                  View
                </a>
              </Col>
            </Row>
          </div>
        </Modal.Body>
        {(onShortlist || onReject) && (
          <Modal.Footer>
            {onShortlist && (
              <button
                className='btn btn-primary me-2'
                onClick={() => {
                  if (window.confirm(`Are you sure you want to shortlist ${data?.name}?`)) {
                    onShortlist()
                  }
                }}
              >
                Shortlist This Candidate
              </button>
            )}
            {onReject && (
              <button
                className='btn btn-warning'
                onClick={() => {
                  if (window.confirm(`Are you sure you want to reject ${data?.name}?`)) {
                    onReject()
                  }
                }}
              >
                Reject This Candidate
              </button>
            )}
          </Modal.Footer>
        )}
      </Modal>
    </div>
  )
}
export default ViewCandidateDetails
